import React from "react";
import { Box } from "@mui/material";
import webProfitMark from "../../images/LogoWebProfit1.svg";

const normalizeSx = (sx) => {
  if (!sx) return [];
  return Array.isArray(sx) ? sx : [sx];
};

/**
 * Loader de marca único de WebProfit.
 *
 * Está pensado para reemplazar spinners genéricos sin alterar el layout que los contiene:
 * - 14–20px: botones, chips e iconos de acción.
 * - 22–32px: feedback inline dentro de cards/listados.
 * - 36px+: estados de carga de sección o pantalla.
 */
export default function WebProfitSpinner({
  size = 36,
  sx,
  label = "Cargando",
  decorative = false,
  ...rest
}) {
  const numericSize = typeof size === "number" ? size : undefined;
  const imageProps = { ...rest };
  // Compatibilidad con las props de CircularProgress que este loader reemplaza.
  // No deben terminar como atributos inválidos del <img>.
  delete imageProps.color;
  delete imageProps.thickness;
  delete imageProps.disableShrink;
  delete imageProps.variant;
  delete imageProps.value;

  return (
    <Box
      component="img"
      src={webProfitMark}
      alt=""
      aria-hidden={decorative || undefined}
      aria-label={decorative ? undefined : label}
      role={decorative ? undefined : "progressbar"}
      {...imageProps}
      sx={[
        {
          width: size,
          height: size,
          minWidth: size,
          minHeight: size,
          display: "block",
          flex: "0 0 auto",
          objectFit: "contain",
          transformOrigin: "50% 50%",
          animation: "wpBrandLoaderSpin 1.45s cubic-bezier(.65,.05,.36,1) infinite",
          "@keyframes wpBrandLoaderSpin": {
            "0%": { transform: "rotate(0deg) scale(.88)", opacity: 0.72 },
            "45%": { transform: "rotate(168deg) scale(1)", opacity: 1 },
            "100%": { transform: "rotate(360deg) scale(.88)", opacity: 0.72 },
          },
          ...(numericSize && numericSize <= 20 ? { verticalAlign: "middle" } : null),
        },
        ...normalizeSx(sx),
      ]}
    />
  );
}
